import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import logo from "../assets/lumacofono-logo.jpeg";
import { LINKS } from "../lib/config";

const NAV = [
  { label: "Le teorie dal mondo", url: LINKS.lumacofono, external: true },
  { label: "Crea la tua ciurma", url: LINKS.ciurma, external: true },
  { label: "SbustaOP", url: LINKS.sbustaop, external: true },
  { label: "Fruttipedia", to: "/", external: false, match: "/" },
  { label: "Tutti i frutti", to: "/catalogo", external: false, match: "/catalogo" },
];

const NavLinks = ({ onClick }) => {
  const { pathname } = useLocation();
  return NAV.map((n) => {
    const current = !n.external && (n.match === pathname || (n.match === "/catalogo" && pathname.startsWith("/catalogo")));
    if (n.external) {
      return (
        <a key={n.label} href={n.url} target="_blank" rel="noopener noreferrer"
          onClick={onClick} data-testid={`nav-${n.label.replace(/\s+/g, "-").toLowerCase()}`}
          className="luma-muted hover:text-[color:var(--luma-ink)] text-sm font-semibold transition-colors">
          {n.label}
        </a>
      );
    }
    return (
      <Link key={n.label} to={n.to} onClick={onClick}
        data-testid={`nav-${n.label.replace(/\s+/g, "-").toLowerCase()}`}
        className={`text-sm font-semibold transition-colors ${current ? "" : "luma-muted hover:text-[color:var(--luma-ink)]"}`}
        style={current ? { color: "var(--luma-action)" } : {}}
        aria-current={current ? "page" : undefined}>
        {n.label}
      </Link>
    );
  });
};

export const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="bg-white border-b sticky top-0 z-30" style={{ borderColor: "var(--luma-line)" }} data-testid="site-header">
      <div className="w-[min(1160px,calc(100%-32px))] mx-auto">
        <div className="relative flex items-center justify-between gap-5" style={{ minHeight: 76 }}>
          <a href={LINKS.lumacofono} target="_blank" rel="noopener noreferrer"
            className="flex items-center gap-3 shrink-0" data-testid="header-logo-link">
            <img src={logo} alt="Lumacofono" className="w-[54px] h-[54px] object-contain shrink-0" />
            <span className="font-display luma-ink" style={{ fontSize: 22, letterSpacing: "-0.045em" }}>Lumacofono</span>
          </a>

          <nav className="hidden lg:flex items-center gap-6" data-testid="desktop-nav">
            <NavLinks />
          </nav>

          <button className="lg:hidden flex items-center justify-center rounded-xl border bg-white"
            style={{ borderColor: "var(--luma-line)", minWidth: 44, minHeight: 44, color: "var(--luma-ink)" }}
            onClick={() => setOpen(!open)} aria-label="Menu" data-testid="mobile-menu-btn">
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>

          {open && (
            <nav className="lg:hidden absolute top-full left-0 right-0 flex flex-col items-stretch gap-1 p-4 bg-white border-b z-40"
              style={{ borderColor: "var(--luma-line)" }} data-testid="mobile-nav">
              <NavLinks onClick={() => setOpen(false)} />
            </nav>
          )}
        </div>
      </div>
    </header>
  );
};
